import { ReactElement } from 'react'

import FindTerms from 'shared/modules/termosUso/domain/usecases/Find'
import TermosUsoRepository from 'shared/modules/termosUso/infra/repositories/TermosUsoRepository'
import ValidateEmailByCodeImpl from '../../domain/usecases/ValidateEmailByCodeImpl'
import SendPinImpl from '../../domain/usecases/SendPinImpl'
import ValidateEmailImpl from '../../domain/usecases/ValidateEmailImpl'
import VerifyPinImpl from '../../domain/usecases/VerifyPinImpl'
import UserRepository from '../../infra/repositories/UserRepository'
import VerifyPhoneAndCnpjImpl from 'modules/user/domain/usecases/VerifyPhoneAndCnpjImpl'
import ChangeGestor from 'modules/user/pages/ChangeGestor'
import ChangeGestorImpl from 'modules/user/domain/usecases/ChangeGestorImpl'

export const ChangeGestorFactory = (): ReactElement => {
  const userRepository = new UserRepository()
  const validateEmailImpl = new ValidateEmailImpl(userRepository)
  const sendPinImpl = new SendPinImpl(userRepository)
  const verifyPinImpl = new VerifyPinImpl(userRepository)
  const changeGestorImpl = new ChangeGestorImpl(userRepository)
  const termosUsoRepository = new TermosUsoRepository()
  const findImpl = new FindTerms(termosUsoRepository)
  const verifyPhoneAndCnpjImpl = new VerifyPhoneAndCnpjImpl(userRepository)
  const validateEmailByCode = new ValidateEmailByCodeImpl(userRepository)

  return (
    <ChangeGestor
      validateEmail={validateEmailImpl}
      validateEmailByCode={validateEmailByCode}
      sendPin={sendPinImpl}
      verifyPin={verifyPinImpl}
      changeGestorImpl={changeGestorImpl}
      findTerms={findImpl}
      verifyPhoneAndCnpj={verifyPhoneAndCnpjImpl}
    />
  )
}
